import { graphql } from "@/lib/gql/__generated__";

export const VoucherForCampaignTestEmailCreate_EditPage_Mutation = graphql(/* GraphQL */ `
	mutation TestEmailCampaignCreated_EditPage($input: TestEmailInput!) {
		testEmailCampaignCreated(input: $input) {
			userErrors
			status
		}
	}
`);
